import Box from '@mui/material/Box';
import { RoundStep } from './RoundStep';
import { RoundStepperBox, RoundStepperBoxProps } from './RoundStepperBox';
import { useMobile } from 'src/hooks/useMobile';
import { calculatePrizes } from 'src/util/bracket/calculatePrizes';
import { createRoundSteps } from 'src/util/bracket/createRoundSteps';
import { calculateRoundStepWidth } from 'src/util/bracket/calculateRoundStepWidth';

export type RoundStepperProps = Omit<
  RoundStepperBoxProps,
  'children' | 'finalRoundPrize' | 'isMobile'
> & {
  roundsCount: number;
  roundPrizes?: (string | undefined)[];
  activeRound?: number;
  activeRoundProgress?: number;
  isLoserBracket?: boolean;
};

export function RoundStepper({
  roundsCount,
  roundPrizes = [],
  activeRound = -1,
  activeRoundProgress,
  isLoserBracket = false,
}: RoundStepperProps) {
  const isMobile = useMobile();

  const { prizes, finalRoundPrize } = calculatePrizes({roundsCount, roundPrizes});

  const { roundSteps, roundStepsReversed } = createRoundSteps({
    roundsCount,
    roundPrizes: prizes,
    activeRound,
    activeRoundProgress,
    isLoserBracket,
    isMobile,
  });

  const roundStepsRendered = [...roundSteps, ...roundStepsReversed];

  return (
    <RoundStepperBox
      finalRoundPrize={finalRoundPrize}
      invert={isLoserBracket}
      isGrandFinal={roundsCount === 1}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: isLoserBracket ? 'flex-end' : undefined,
          justifyContent: isMobile ? 'flex-start' : 'center',
          width: '100%',
        }}
      >
        {roundStepsRendered.map((roundStep, index) => {
          return (
            <Box
              key={index}
              sx={{
                width: calculateRoundStepWidth({
                  isMobile,
                  roundStep,
                  index,
                  roundsCount,
                }),
              }}
            >
              <RoundStep {...roundStep} invert={isLoserBracket} />
            </Box>
          );
        })}
      </Box>
    </RoundStepperBox>
  );
}
